module.exports = __webpack_public_path__ + "img/grupowe1.45ccb361.webp";